export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIME_OUT = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'fb6ceca0-72c8-4211-b7a3-51a34f840393';
export const MODAL_CLOSE_SEC = 2500;
